import { postTrackingData } from "@/api/endpoints/track";
import { SORTING_OPTION, SortingOption, SOURCE } from "@/constants";
import { useMentionCards } from "@/contexts/MentionCardsContext";
import useFilterParams from "@/hooks/useFilterParams";
import { useOrganization } from "@/hooks/useOrganization";
import {
  Select,
  SelectItem,
  SelectValue,
  SelectContent,
  SelectTrigger,
} from "@components/ui/select";
import { i18n } from "@lingui/core";

const SORT_OPTIONS = [
  {
    key: "date",
    value: SORTING_OPTION.DATE,
    label: L.MENTIONS_VIEW_TOOLBAR_SORT_BUTTON_BY_DATE,
  },
  {
    key: "reach",
    value: SORTING_OPTION.REACH,
    label: L.MENTIONS_VIEW_TOOLBAR_SORT_BUTTON_BY_REACH,
  },
  {
    key: "relevance",
    value: SORTING_OPTION.RELEVANCE,
    label: L.MENTIONS_VIEW_TOOLBAR_SORT_BUTTON_BY_RELEVANCE,
  },
];

const SORT_OPTIONS_US_ONLY_ACCOUNTS = [
  ...SORT_OPTIONS,
  {
    key: "popularity",
    value: "popularity",
    label: L.MENTIONS_VIEW_TOOLBAR_SORT_BUTTON_BY_POPULARITY,
  },
];

const SortButton = () => {
  const [filters, setFilters] = useFilterParams();
  const { data: orgData } = useOrganization();
  const plan = orgData?.ok ? orgData.data.plan : null;
  const isUsOnlyOrganization =
    plan?.markets.length === 1 && plan?.markets[0] === "us";

  const { alert } = useMentionCards();

  const alertHasPodcastSource = alert?.sources.includes(SOURCE.PODCAST);

  // US-only organzations can also sort by popularity
  const sortOptions =
    isUsOnlyOrganization && alertHasPodcastSource
      ? SORT_OPTIONS_US_ONLY_ACCOUNTS
      : SORT_OPTIONS;

  return (
    <Select
      value={filters.sort_by || SORTING_OPTION.DATE}
      onValueChange={(newValue) => {
        postTrackingData("Mentions sorted", { sort_by: newValue });
        setFilters({
          sort_by:
            newValue === SORTING_OPTION.DATE
              ? undefined
              : (newValue as SortingOption),
        });
      }}
    >
      <SelectTrigger data-testid="filter-bar--sorting">
        <SelectValue>
          {(sortBy: string | null) => {
            const option = sortOptions.find(({ value }) => value === sortBy);

            return option ? i18n._(option.label) : null;
          }}
        </SelectValue>
      </SelectTrigger>

      <SelectContent>
        {sortOptions.map(({ value, label }) => (
          <SelectItem
            key={value}
            value={value}
            data-testid={`sort-option-${value}`}
          >
            {i18n._(label)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default SortButton;
